import React from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTranslation } from 'react-i18next';
import ProjectChatData from './ProjectChatData';

export default function ProjectChatReferenceAnswer({ answer }) {
  const { t } = useTranslation();
  return <Box>
    <ProjectChatData value={answer.value} />
    <Accordion disableGutters elevation={0}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="caption">{t('project_chat.evidence')}</Typography>
      </AccordionSummary>
      <AccordionDetails>{answer.evidence.map((proof, index) => <Box key={index} sx={{ mb: 1 }}>
        <Typography variant="caption">{proof.title}
          {proof.page ? ` · ${t('project_chat.job.visual_observation', { page: proof.page })}` : ''}</Typography>
        <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{proof.quote}</Typography>
      </Box>)}</AccordionDetails>
    </Accordion>
    {answer.sources.some(source => source.partial) && <Typography variant="caption" color="text.secondary">
      {t('project_chat.references.partial')}
    </Typography>}
  </Box>;
}
